import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterByCategory',
  standalone: false,
})
export class FilterItemByCategoryPipe implements PipeTransform {
  transform(items: Array<any>, category: string): Array<any> {
    if (!items || !category) {
      return items || [];
    }
    return items.filter((item) => item.group === category);
  }
}
